export const searchProductsSerializer = (collection) => {
  return collection.map((product) => {
    return {
      ...product,
      baseImage: product.baseImage[0],
    };
  });
};
